import { render } from "./SectionMenuEntry.vue?vue&type=template&id=45542048"
import script from "./SectionMenuEntry.vue?vue&type=script&lang=ts"
export * from "./SectionMenuEntry.vue?vue&type=script&lang=ts"
script.render = render

export default script